import { RouteObject } from 'react-router-dom';

import { Otp } from './Otp';

export const otpRoute: RouteObject = {
  path: 'otp',
  element: <Otp />,
};